import { RedirectWithQuery } from '@xylabs/sdk-react'
import { useContext } from 'react'

import { AuthenticationContext, GeotokensSettingsLoader } from '../../Contexts'
import { GeotokenSettingsListHeader } from '../../Toolbar'
import WorldBasePage from '../WorldBasePage'
import InnerPage from './InnerPage'

const GeotokensSettingsPage: React.FC = () => {
  const { auth, authEntity } = useContext(AuthenticationContext)

  if (auth?.authenticated() === false || (authEntity && authEntity?.admin !== true)) {
    return <RedirectWithQuery to="/auctions" />
  }

  return (
    <WorldBasePage>
      <GeotokensSettingsLoader>
        <GeotokenSettingsListHeader />
        <InnerPage />
      </GeotokensSettingsLoader>
    </WorldBasePage>
  )
}

export default GeotokensSettingsPage
